module.exports = __webpack_public_path__ + "img/witchy.23b41eba.jpg";